var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-right user-select comtt_c"},[_c('el-card',{staticClass:"box-card humtog_s"},[_c('p',[_vm._v("Joined - "+_vm._s(_vm.date))])])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69e311d8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/sidebars/UsersSidebar.vue
// module id = yQoL
// module chunks = 0